import {
    Navigate,
    useNavigate,
    useParams,
} from "react-router-dom";
import PageHeading from "../../PageHeading/PageHeading";
import "./OrderPageV2.css";
import {
    parseApiError,
    parseRequestNumber,
} from "../../../../assets/utils/utils";
import { useContext, useEffect, useState } from "react";
import ItemForm from "../../ItemForm/ItemForm";
import {
    ORDERS_MAIN_LINK,
    PLATFORM_MAIN_LINK,
} from "../../../../assets/utils/constants";
import { UserContext } from "../../../../assets/contexts/userContext";
import mainApi from "../../../../assets/api/MainApi";
import useAutoDismissError from "../../../../assets/hooks/useAutoDismissError";
import PreloaderBox from "../../../PreloaderBox/PreloaderBox";
import OrderInfo from "./OrderInfo/OrderInfo";
import DeliveryInfo from "./DeliveryInfo/DeliveryInfo";
import OrderControls from "./OrderControls/OrderControls";
import OrderTimer from "./OrderTimer/OrderTimer";
import OrderCart from "./OrderCart/OrderCart";
import useWindowSize from "../../../../assets/hooks/useWindowSize";
import OrderPdfDownloadButton from "./OrderPdfDownloadButton/OrderPdfDownloadButton";
import { DownloadIcon } from "../../../../assets/icons/controls/controls";
import MiniPreloader from "../../../MiniPreloader/MiniPreloader";

function OrderPageV2() {
    const navigate = useNavigate();
    const { user } = useContext(UserContext);
    const { id } = useParams();
    const [isPreloaderVisible, setIsPreloaderVisible] = useState(true);
    const [order, setOrder] = useState(null);
    const [error, showError] = useAutoDismissError();
    const [items, setItems] = useState(null)
    const [config, setConfig] = useState(null)
    const { width } = useWindowSize()
    useEffect(() => {
        if (!user) return;
        const shop_id = user?.default_shop?._id;
        let isCancelled = false;

        function fetchOrderItemsRecursively(last_id = null, accumulatedItems = []) {
            return mainApi
                .getOrderItems({ shop_id, _id: id, last_id })
                .then((res) => {
                    const currentItems = accumulatedItems.concat(res.data);

                    if (res.is_more) {
                        return fetchOrderItemsRecursively(res.data[res.data.length - 1]._id, currentItems);
                    }

                    return currentItems;
                });
        }

        async function loadOrderData() {
            setIsPreloaderVisible(true);

            try {
                const [orderData, orderConfig, orderItems] = await Promise.all([
                    mainApi.getExactOrder({ shop_id, _id: id }),
                    mainApi.getOrderConfig({ shop_id }),
                    fetchOrderItemsRecursively(),
                ]);

                if (isCancelled) return;

                setOrder(orderData);
                setConfig(orderConfig);
                setItems(orderItems);
            } catch (err) {
                if (isCancelled) return;

                if (err.statusCode === 403) {
                    setOrder(null);
                    setConfig(null);
                    setItems(null);
                }

                showError(parseApiError(err));
            } finally {
                if (!isCancelled) {
                    setIsPreloaderVisible(false);
                }
            }
        }

        loadOrderData();

        return () => {
            isCancelled = true;
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, id]);


    const pdfAction = !isPreloaderVisible && order && items && width <= 780 ? (
        <OrderPdfDownloadButton
            order={order}
            items={items}
            ariaLabel="Выгрузить заказ в PDF"
            className="order-page__pdf-action"
            renderContent={({ loading }) => (
                loading
                    ? <MiniPreloader />
                    : (
                        <DownloadIcon
                            mainClassName="order-page__pdf-icon"
                            strokeClassName="order-page__pdf-icon-stroke"
                        />
                    )
            )}
        />
    ) : null;


    return (
        <div className="order-page">
            <PageHeading
                goBack={{
                    onClick: () => {
                        navigate(`${PLATFORM_MAIN_LINK}/${ORDERS_MAIN_LINK}`);
                    },
                }}
                className={"order-page__heading"}
                title={
                    isPreloaderVisible ?
                        "Заказ загружается..."
                        :
                        order?.ai_id
                            ? `Заказ ${parseRequestNumber(order.ai_id)}`
                            : ""
                }
                rightSlot={pdfAction}
            />
            <ItemForm
                mainClassName={''}
                containerClassName={'order-page__item-container'}
            >
                {isPreloaderVisible ?
                    <PreloaderBox />
                    :
                    order && config && items ?
                        <div className="order-page__container">
                            {console.log({ order, config, items })}
                            <div className="order-page__content">
                                {width <= 780 ?
                                    <OrderTimer
                                        order={order}
                                    />
                                    : null}
                                {width > 780 ?
                                    <OrderControls
                                        order={order}
                                        config={config}
                                        items={items}
                                        setOrder={setOrder}
                                    />
                                    : null}

                                <OrderCart
                                    order={order}
                                    config={config}
                                    items={items}
                                    setItems={setItems}
                                    setOrder={setOrder}
                                />
                            </div>
                            <div className="order-page__infos">
                                {width > 780 ?
                                    <OrderTimer
                                        order={order}
                                    />
                                    : null}
                                <OrderInfo
                                    order={order}
                                />
                                <DeliveryInfo
                                    order={order}
                                />
                            </div>
                        </div>
                        :
                        <Navigate to={`${PLATFORM_MAIN_LINK}/${ORDERS_MAIN_LINK}`} />
                }
            </ItemForm>


        </div>
    );
}

export default OrderPageV2;
